export type LanguageID = number;

export enum LANGUAGE_CODES {
  Dutch = "nl-NL",
  English = "en-GB",
  French = "fr-FR",
  German = "de-DE",
  TurboHoets = "th-FR",
  Afrikaans = "af-AF",
  Bosnian = "bs-BS",
  Greek = "el-GR",
  Hungarian = "hu-HU",
  Polish = "pl-PL",
  Romanian = "ro-RO"
}

export interface Language {
  language_code: string; // Language code
  tablet_only: boolean; // This language is exclusive for tablet
}
